export default "__VITE_ASSET__CLI3mwMZ__"